import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from 'src/app/seguranca/auth.service';
import { environment } from 'src/environments/environment';
import { ClockService } from '../service/clock.service';
import { filter, map, startWith } from 'rxjs';

const ROTAS_SEM_FOOTER = ['/atalhos'];

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [DatePipe],
})
export class FooterComponent implements OnInit {
  private readonly clockService = inject(ClockService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  dataAtual: Date = new Date();
  version = environment.version;
  empresa: string = '';
  copyright: string = '';

  private readonly ocultarFooter = toSignal(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => ROTAS_SEM_FOOTER.some((r) => (e as NavigationEnd).url.includes(r))),
      startWith(ROTAS_SEM_FOOTER.some((r) => this.router.url.includes(r))),
    ),
    { initialValue: ROTAS_SEM_FOOTER.some((r) => this.router.url.includes(r)) },
  );

  @HostBinding('style.display')
  get display(): string {
    return this.ocultarFooter() ? 'none' : '';
  }

  ngOnInit() {
    this.empresa = this.authService.jwtPayload?.empresa ?? '';
    this.copyright = environment.configuracaoThema.copyright;
    this.clockService.getClock().subscribe((time) => (this.dataAtual = time));
  }
}
